import React, { Component } from 'react';
import './ShareButton.css';

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  doShare() {
    let resultPara = { textContent: ""};
    const shareData = {
      title: 'Yliskulma-tietovisa',
      text: 'Testaa mitä tiedät Yliskulmasta!',
      url: 'https://yliskulmavisa.web.app',
    };
    // Must be triggered some kind of "user activation"
    (async () => {
      try {
          console.log(navigator.share);
          await navigator.share(shareData)
          resultPara.textContent = 'MDN shared successfully'
      } catch(err) {
          resultPara.textContent = 'Error: ' + err
      }}
    )();
  }

  render() {
    return (
      <div className="ShareButton">
        <button onClick={this.doShare}>
          Jaa
        </button>
      </div>
    );
  }
}

export default ShareButton;
